import {
  columnCover,
  columnName,
  columnLevel,
  columnTags,
  columnAvatars,
  columnPreview,
  columnProductIds,
} from 'components/template-data-table-column'
import React from 'react'
import { openOnlinesByPainter } from 'commons/worksLinks'
import DisplayUpdateTime from 'ui/DisplayUpdateTime'
import { DataTableRowActions } from './data-table-row-action'

const columnPainterFrames = {
  header: 'Painter',
  accessorKey: 'painter',
  cell: ({ row, table }) => {
    const authorId = row.original.author
    const name = row.original.publisher
    const onPainterClick = table.options.meta?.onPainterClick

    if (!authorId) {
      return <span>{name || '-'}</span>
    }

    if (onPainterClick) {
      return (
        <button
          type="button"
          className="font-medium underline underline-offset-4"
          onClick={() => onPainterClick(authorId)}
          title={authorId}
        >
          {name || authorId}
        </button>
      )
    }

    return (
      <button
        type="button"
        className="font-medium underline underline-offset-4"
        onClick={() => openOnlinesByPainter(authorId)}
        title={authorId}
      >
        {name || authorId}
      </button>
    )
  },
}

const formatRate = (v) => {
  if (v === undefined || v === null || Number.isNaN(Number(v))) return '—'
  return `${v}%`
}

const columnRates = {
  header: 'Rates',
  cell: ({ row }) => {
    const {
      d1UsageRate,
      d1UsNewClickRate,
      d1UsNewUsageRate,
      d1UsNewDoneRate,
    } = row.original
    return (
      <div className="flex flex-col gap-1 whitespace-nowrap text-xs tabular-nums">
        <div className="flex gap-2 text-slate-700">
          <span>
            <span className="text-slate-500">点击率:</span>
            {formatRate(d1UsNewClickRate)}
          </span>
          <span>
            <span className="text-slate-500">使用率:</span>
            {formatRate(d1UsNewUsageRate)}
          </span>
          <span>
            <span className="text-slate-500">完成率:</span>
            {formatRate(d1UsNewDoneRate)}
          </span>
        </div>
        <div className="text-slate-900">
          <span className="text-slate-500">D1 使用率:</span>
          {formatRate(d1UsageRate)}
        </div>
      </div>
    )
  },
}

export const columns = [
  {
    header: '#',
    cell: ({ row }) => row.index + 1,
  },
  columnCover,
  columnPreview,
  columnName,
  columnPainterFrames,
  columnLevel,
  columnTags,
  columnProductIds,
  columnAvatars,
  {
    header: 'CreateTime',
    accessorKey: 'createTime',
    cell: ({ row }) => (
      <DisplayUpdateTime updateTime={row.original.createTime} />
    ),
  },
  columnRates,
  {
    header: 'Reported',
    accessorKey: 'reportCount',
    cell: ({ row }) => <div>{row.original.reportCount ?? 0}</div>,
  },
  {
    header: 'Actions',
    cell: ({ row }) => {
      return <DataTableRowActions row={row} />
    },
  },
]
